import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';

import * as paths from 'app-router/paths';
import { useStore } from 'stores';
import Loading from 'components/Loading';
import Pagination from 'components/Pagination';
import { ErrorMessage, Message } from 'components/Message';
import { FindIcon, LabeledIcon, ReloadIcon } from 'components/Icon';

import { ToggleCreator } from './ToggleCreator';
import { FeatureToggleView } from './FeatureToggleView';
import { FeatureToggle } from 'stores/ToggleStore';
import { SimpleInlineHelp } from 'components/InlineHelp';

export const Page: React.FC = observer(() =>
{
  const { uiStore, toggleStore } = useStore();
  const history = useHistory();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const pageFromQuery = parseInt(query.get('p') || '1');
  const page = pageFromQuery ? pageFromQuery - 1 : 0;
  const searchQuery = query.get('q') || '';
  const [searchQueryCollector, setSearchQueryCollector] = useState(searchQuery);

  useEffect(() =>
  {
    toggleStore.findAsync(searchQuery, page);
  }, [toggleStore, searchQuery, page]);

  const reloadDataHandler = async () => await toggleStore.findAsync(searchQuery, page);
  const searchHandler = () => history.push(paths.buildToggleListPath(searchQueryCollector, `${1}`));
  const onPageHandler = (page: number) => history.push(paths.buildToggleListPath(searchQueryCollector, `${page + 1}`));

  return (
    <article className="page toggle-list">
      <h1>{uiStore.labels.pages.toggles.title}<SimpleInlineHelp>{uiStore.labels.help.toggles.about}</SimpleInlineHelp></h1>
      {
        toggleStore.pagedFeatureToggles.isLoading
        ? <Loading />
        : toggleStore.pagedFeatureToggles.isError
          ? <ErrorMessage>
              {toggleStore.pagedFeatureToggles.errorMessage}
              <button onClick={reloadDataHandler}>
                <LabeledIcon label={uiStore.labels.common.tryAgain}><ReloadIcon/></LabeledIcon>
              </button>
            </ErrorMessage>
          : <div className="content">
              <div className="action-bar">
                <input type="text"
                       className="search"
                       placeholder="Search for toggles"
                       value={searchQueryCollector}
                       onChange={e => setSearchQueryCollector(prev => e.target.value)}
                       onKeyPress={async e => e.key === 'Enter' ? searchHandler() : null}/>
                <button onClick={searchHandler}><FindIcon/></button>
              </div>
              <div className="pagination">
                <Pagination currentPage={toggleStore.pagedFeatureToggles.data?.page || 0}
                            totalPages={toggleStore.pagedFeatureToggles.data?.total || 0}
                            onPage={onPageHandler}/>
              </div>
              <ToggleCreator onSuccess={(x) => { setSearchQueryCollector(prev => x.token || prev); history.push(paths.buildToggleListPath(x.token, `${1}`)) }}/>
              {
                toggleStore.pagedFeatureToggles.data?.data && toggleStore.pagedFeatureToggles.data.data.length > 0
                ? toggleStore.pagedFeatureToggles.data.data.map(x => x as FeatureToggle).map(x => <FeatureToggleView key={x.id} featureToggle={x} />)
                : <Message>{uiStore.labels.common.noResults}</Message>
              }
            </div>
      }
    </article>
  );
});